import { useCallback } from "react";
import { useTimezone } from "@/elements/context/timezone";
import { formatDate } from "@/elements/utils/format-date";

export function useFormatDate() {
  const timezoneIdentifier = useTimezone();

  return useCallback(
    (timestamp: number, pattern: string) =>
      formatDate(timestamp, pattern, timezoneIdentifier),
    [timezoneIdentifier],
  );
}
